import { takeEvery, call, put } from 'redux-saga/effects'
import {
  API_SERVER,
  GET_ADMIN_USERS_LIST,
  SELECT_USER,
  GET_USER_INFO,
  CLEAR_SELECTED_USER
} from '../constants'
import store from '../store'
import { apiManualPost } from '../utils/request'
import {
  getAdminUsersListSuccess,
  getAdminUsersListFail,
  loadProfileFailed,
  loadProfileSuccess,
  selectUserSuccess,
  getUserInfo,
  //loadProfileStart,
  getCustomersChart,
  getInvoiceChart,
  getInvoicesStart,
  getUserTaxInfo,
  getExpenseStart,
  getCustomersStart,
  getNewSalaryStart,
  getUserYelInfo,
  getTaxCard,
  getIndustryTaxCard,
  getReferralDiscountByEmail,
  getLogo,
  getInvoiceUserEmail,
  getUserCompanyUpdateInfo,
  getUserLifeTimeInfo,
  getInvoiceAndSalaryDetailMonthly,
  getSalariesStart
} from '../actions'
import { resetForm, updateFormValues, setFieldValue } from '../form'

function* getUsersList() {
  try {
    const uuid = store.getState().client.user.data[2]

    if (!!uuid) {
      const url = `${API_SERVER}/GetAdminUsersList`
      const data = {
        uuid
      }

      const body = JSON.stringify(data)
      const result = yield call(apiManualPost, url, body)
      const parsedResult = JSON.parse(result.data)

      if (result.data) {
        /*     yield put(openSuccessSnackbar()) */

        yield put(getAdminUsersListSuccess(parsedResult))
      } else {
        yield put(getAdminUsersListFail())
      }
    }
  } catch (e) {
    yield put(getAdminUsersListFail())
  }
}

function* selectUserSaga({ data }) {
  const usersList = store.getState().adminUser.usersList
  let userInfo = data.toString().trimEnd()
  let userData = usersList.filter((x) => x.email == userInfo)

  try {
    yield put(getUserInfo(userData[0]))
    //yield put(loadProfileStart(userData[0]))
    yield put(getUserYelInfo(userData[0]))
    yield put(getCustomersChart(userData[0]))
    yield put(getInvoiceChart(userData[0]))
    yield put(getInvoicesStart(userData[0]))
    yield put(getUserTaxInfo(userData[0]))
    yield put(getCustomersStart(userData[0]))
    yield put(getExpenseStart(userData[0]))
    yield put(getSalariesStart(userData[0]))
    yield put(getNewSalaryStart(userData[0]))
    yield put(getTaxCard(userData[0]))
    yield put(getIndustryTaxCard(userData[0]))
    yield put(getReferralDiscountByEmail(userData[0]))
    yield put(getLogo(userData[0]))
    yield put(getInvoiceUserEmail(0, userData[0]))
    yield put(getUserCompanyUpdateInfo(userData[0]))
    yield put(getUserLifeTimeInfo(userData[0]))
    yield put(getInvoiceAndSalaryDetailMonthly(userData[0]))
  } catch (e) {
    console.log('err in selectUserSaga ', e)
  }
}

function* getUserInfoSaga({ data }) {
  try {
    const uuid = data.uuid
    if (!!uuid) {
      const url = `${API_SERVER}/GetUserContactDetails`

      const body = JSON.stringify({ uuid: uuid })
      const result = yield call(apiManualPost, url, body)
      const resultParsed = JSON.parse(result.data)

      yield put(loadProfileSuccess(resultParsed))
      yield put(selectUserSuccess(resultParsed))

      yield put(updateFormValues('profile', resultParsed))
      yield put(
        setFieldValue('tax', {
          field: 'tax_percentage',
          value: resultParsed['tax_percentage']
        })
      )
    }
  } catch (e) {
    yield put(loadProfileFailed(e))
  }
}

function* clearSelectedUserSaga() {
  yield put(resetForm('profile'))
  yield put(resetForm('tax'))
  yield put(resetForm('yel')) // PI-301 YEL form at Oma tiedot
  yield put(resetForm('taxArea')) // PI-301 Valtticard

  yield put(
    setFieldValue('invoice', {
      field: `groupInvoiceRow.${0}.groupEmail`,
      value: ''
    })
  )
}

export function* watchGetUsersList() {
  yield takeEvery(GET_ADMIN_USERS_LIST, getUsersList)
}

export function* watchSelectUser() {
  yield takeEvery(SELECT_USER, selectUserSaga)
}

export function* watchGetUserInfo() {
  yield takeEvery(GET_USER_INFO, getUserInfoSaga)
}

export function* watchClearSelectedUser() {
  yield takeEvery(CLEAR_SELECTED_USER, clearSelectedUserSaga)
}
